// Shows a sticky add-to-cart bar once the main add-to-cart button scrolls out of view,
// and forwards its button press to that main button so the product form stays the single source of truth.
class SStickyAtc extends HTMLElement {
  #controller = null;
  #observer = null;

  connectedCallback() {
    this.#controller = new AbortController();
    this.addEventListener('command', (event) => {
      if (event.command !== '--add') return;
      const main = document.querySelector(this.dataset.target);
      if (main) main.click();
    }, { signal: this.#controller.signal });

    const watch = document.querySelector(this.dataset.watch);
    if (!watch) return;
    this.#observer = new IntersectionObserver(([entry]) => {
      const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      this.toggleAttribute('data-visible', passed);
      this.inert = !passed;
    });
    this.#observer.observe(watch);
  }

  disconnectedCallback() {
    this.#controller?.abort();
    this.#observer?.disconnect();
  }
}

if (!customElements.get('s-sticky-atc')) customElements.define('s-sticky-atc', SStickyAtc);
